export default __webpack_public_path__ + "static/media/hero-image_school.0da3bfb0.svg";